import { createContext } from 'react';
import { Configuration } from '@spotify-internal/remote-config-properties';
export const RemoteConfigContext = createContext(new Configuration.Delegate(() => {
    throw new Error('Please wrap your component in RemoteConfig Provider');
}));
//# sourceMappingURL=remoteConfigContext.js.map